import { LineClamp } from '@/components/LineClamp';
import { TeamDirectoryBox } from '@lemontaps/lib/types/api';
import { flexCenterProps } from '@/util';
import { Card, CardActionArea, CardContent, Typography, Avatar, Box } from '@mui/material';
import { SLIDE_SIZE } from '..';
import { customCssClasses } from '@lemontaps/lib/constants/profile-page/customCssClassNames';
export default function TeamMember({
  teamMember,
}: {
  teamMember: TeamDirectoryBox['team'][number];
}) {
  return (
    <Card
      sx={{ maxWidth: 210, border: 'none', boxShadow: 'none' }}
      component='a'
      href={teamMember.profileUrl || '#'}
      target='_blank'
      className={customCssClasses.teamDirectoryBox.teamMember.className}
    >
      <CardActionArea
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        <Box {...flexCenterProps}>
          <Avatar
            className={customCssClasses.teamDirectoryBox.teamMemberImage.className}
            src={teamMember.imageUrl}
            alt={teamMember.fullName}
            sx={{
              width: `calc(${SLIDE_SIZE} * 0.75)`,
              height: `calc(${SLIDE_SIZE} * 0.75)`,
              mt: '10%',
            }}
            aria-hidden
          />
        </Box>
        <CardContent>
          <Typography
            gutterBottom
            variant='h5'
            component='div'
            className={customCssClasses.teamDirectoryBox.teamMemberName.className}
          >
            <LineClamp lineCount={1} text={teamMember.fullName} />
          </Typography>
          <Typography
            variant='body2'
            sx={{ color: 'text.secondary' }}
            className={customCssClasses.teamDirectoryBox.teamMemberPosition.className}
          >
            {/* force whitespace so that all boxes have the same height */}
            <LineClamp lineCount={1} text={teamMember.subtitle || ' '} />
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
